import { render, staticRenderFns } from "./TableChart.vue?vue&type=template&id=f1c6646c&scoped=true&"
import script from "./TableChart.vue?vue&type=script&lang=js&"
export * from "./TableChart.vue?vue&type=script&lang=js&"
import style0 from "./TableChart.vue?vue&type=style&index=0&id=f1c6646c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c6646c",
  null
  
)

export default component.exports